import { Box, Button, Card, Typography } from "@mui/material";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import DashboardGraphs from "../../Components/DashboardGraphs";
import DashOverviewCards from "../../../Shared-ui/SharedComponents/Cards/DashOverviewCards";
import { useEffect, useState } from "react";

import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { useDispatch } from "react-redux";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { DASHBOARD_ACTIVITY, DASHBOARD_AGENT, DASHBOARD_CONVERSATION_METRICS, DASHBOARD_KNOWLEDGE_BASE } from "../../../Services/Endpoint";
import { OverviewCardData } from "../../../Shared-ui/Types/common";
import variables from "../../../assets/styles/variables.module.scss";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";



const DashboardOverview = () => {
  const dispatch = useDispatch();
  const [cardDataAgent, setCardDataAgent] = useState<OverviewCardData>()
  const [cardDataKW, setCardDataKW] = useState<OverviewCardData>()
  const [cardDataConversation, setCardDataConversation] = useState<OverviewCardData>()
  const [cardDataConMetrics, setCardDataConMetrics] = useState<OverviewCardData>()
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
      await getAgentData();
      await getKnowledgeData()
      await getActivityConversation()
      await getConversationMetricsData()
    };
    fetchData();
  }, []);

  const manualRefresh = async () => {
    setRefreshKey(prev => prev + 1);
    await getAgentData();
    await getKnowledgeData()
    await getActivityConversation()
    await getConversationMetricsData()
  }
  const getAgentData = async () => {
    try {
      dispatch(StartLoading())
      const data = await BaseInstance.get(DASHBOARD_AGENT).then(res => res?.data)
      const agentData = {
        title: "Total Agents",
        value: data.total_own,
        subText: `${data.with_knowledge} with knowledge`,
        icon: <PeopleOutlineIcon />,
        color: "#04db93",
        // percentageChange: 33.3,
      }
      setCardDataAgent(agentData)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading())
    }
  }

  const getKnowledgeData = async () => {
    try {
      dispatch(StartLoading())
      const data = await BaseInstance.get(DASHBOARD_KNOWLEDGE_BASE).then(res => res?.data)
      const kwtData = {
        title: "Knowledge",
        value: data.total_knowledge_bases,
        subText: `${data.total_documents} data units`,
        icon: <AutoStoriesOutlinedIcon />,
        color: "#05dabb",
        // percentageChange: 25,
      }
      setCardDataKW(kwtData)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading())
    }
  }

  const getActivityConversation = async () => {
    try {
      dispatch(StartLoading())
      const data = await BaseInstance.get(DASHBOARD_ACTIVITY).then(res => res?.data)
      const conversationData = {
        title: "Conversations",
        value: data.total_conversations,
        subText: `${data.total_messages} messages`,
        icon: <ChatBubbleOutlineOutlinedIcon />,
        color: "#03c0d9",
        // percentageChange: -17.99,
      }
      setCardDataConversation(conversationData)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading())
    }
  }

  const getConversationMetricsData = async () => {
    try {
      dispatch(StartLoading())
      const data = await BaseInstance.get(DASHBOARD_CONVERSATION_METRICS).then(res => res?.data)
      const metricsData = {
        title: "Avg Response Time",
        value: data.avg_response_time_ms,
        subText: `${data.avg_time_to_first_token_ms} average response`,
        icon: <AccessTimeOutlinedIcon />,
        color: "#01aeee",
        // percentageChange: 0.95,
      }
      setCardDataConMetrics(metricsData)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading())
    }
  }

  return (
    <Box
      sx={{
        mb: 4,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          // mt: "-54px",
          mt: { xs: "0", sm: "-54px" },
          mb: 3,
        }}
      >
        <Button
          variant="outlined"
          startIcon={<CachedOutlinedIcon />}

          onClick={() => manualRefresh()}
          sx={{
            width: { xs: "100%", sm: "auto" },
            // borderColor: variables.primaryButton,
            // color: variables.primaryButton,
            textTransform: "capitalize",
            "&:hover": {
              borderColor: "primary.dark",
              color: "primary.dark",
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
          }}
        >
          Manual Refresh
        </Button>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "repeat(4, 1fr)",
          },
          gap: 3,
          mb: 4,
        }}
      >
        {cardDataAgent && <DashOverviewCards data={cardDataAgent} />}
        {cardDataKW && <DashOverviewCards data={cardDataKW} />}
        {cardDataConversation && <DashOverviewCards data={cardDataConversation} />}
        {cardDataConMetrics && <DashOverviewCards data={cardDataConMetrics} />}

      </Box>
      <DashboardGraphs refreshKey={refreshKey} />
    </Box>
  );
};

export default DashboardOverview;
